import { Card, CardHeader, CardContent, Skeleton, Box } from '@mui/material';

const LoadingItem = (props) => {
  const { height, width, sx } = props;
  return (
    <Box component="div" sx={sx}>
      <Card sx={{ m: 0, p: 0 }} elevation={0}>
        <CardHeader
          title={<Skeleton
            animation="wave"
            height={10}
            width="80%"
            style={{ marginBottom: 6 }}
          />}
          subheader={<Skeleton animation="wave" height={10} width="40%" />}
        />
        <Skeleton sx={{ height: height || 300, width: width || '100%' }} animation="wave" variant="rectangular" />
      </Card>
    </Box>
  );
}

export default LoadingItem;
